<form class="w-[40vw] h-[40vh] flex" [formGroup]="createFeedbackForm">
  <div class="w-[50%] h-[100%] pr-10">
    <div class="pt-1 pb-2">
      <p-select-button [options]="feedbackTypeOptions" formControlName="feedbackType" size="large" [invalid]="isInvalid('feedbackType')" (onChange)="onFeedbackTypeChange()"/>
    </div>
    @if (createFeedbackForm.value.feedbackType=='Feedback') {
      <div class="pb-2">
        <p-select-button [options]="feedbackSeverityOptions" formControlName="feedbackSeverity" [invalid]="isInvalid('feedbackSeverity')"/>
      </div>
    }
    @if (createFeedbackForm.value.feedbackType=='Error') {
      <div class="pb-2">
        <p-select-button [options]="errorSeverityOptions" formControlName="errorSeverity" [invalid]="isInvalid('errorSeverity')"/>
      </div>
    }
    @if (createFeedbackForm.value.feedbackType=='MissingFeature') {
      <div class="pb-2">
        <p-select-button [options]="missingFeatureSeverityOptions" formControlName="missingFeatureSeverity" [invalid]="isInvalid('missingFeatureSeverity')"/>
      </div>
    }

    <textarea rows="10" cols="60" pTextarea formControlName="description" name="description"
    [placeholder]="'Feedback.Description'|translate" [invalid]="isInvalid('description')"></textarea>
    <div>
      <p-checkbox class="mr-2" formControlName="hasPermissionToContact" [binary]="true"/>
      <label>{{ "Feedback.ContactConsentText"|translate }}</label>
    </div>
  </div>
  <div class="w-[50%] h-[100%] flex flex-col justify-evenly">
    @if (createFeedbackForm.value.feedbackType=='Feedback') {
      <div>
        {{ 'Feedback.DataDeclarationSentence1'|translate }}
      </div>
      <div>{{ 'Feedback.DataDeclarationYourAccountInformation'|translate }}</div>
      <div>{{ 'Feedback.DataDeclarationCurrentPage'|translate }}</div>
      <div>{{ 'Feedback.DataDeclarationNoVisibleDataBeingTransmitted'|translate }}</div>
      <div class="text-sm">{{ 'Feedback.DataDeclarationNoSentDataBeingSold'|translate }}</div>
      <div class="flex flex-col justify-end">
        <button pButton pRipple label="{{'Feedback.DataDeclarationAcceptAndSend'|translate}}"
        (click)="SendFeedback()"></button>
      </div>
    }
    @if (createFeedbackForm.value.feedbackType=='Error') {
      <div>
        {{ 'Feedback.DataDeclarationSentence1'|translate }}
      </div>
      <div>{{ 'Feedback.DataDeclarationYourAccountInformation'|translate }}</div>
      <div>{{ 'Feedback.DataDeclarationCurrentPage'|translate }}</div>
      <div>{{ 'Feedback.DataDeclarationBrowserInfos'|translate }}</div>
      @if (feedbackDataService.feedbackData) {
        <div>{{ 'Feedback.DoYouWantToSendData'|translate }}</div>
        <div class="grid grid-cols-6 grid-rows-4 gap-y-2">
          <div>
            <p-radio-button formControlName="hasPermissionToAccessData" [value]="false"/>
          </div>
          <div class="col-span-5">
            {{"Feedback.NoSpecificData"|translate}}
          </div>
          <div>
            <p-radio-button class="mr-2" formControlName="hasPermissionToAccessData" [value]="true"/>
          </div>
          <div class="col-span-5 row-span-4">
            <div>
              {{"Feedback.FollowingDataBeingSent"|translate}}
            </div>
            @if (feedbackDataService.feedbackData.treatmentId) {
              <div>
                {{ 'Feedback.TreatmentDetails'|translate }}
              </div>
            }
            @if (feedbackDataService.feedbackData.petId) {
              <div>
                {{ 'Feedback.PetDetails'|translate }}
              </div>
            }
            @if (feedbackDataService.feedbackData.customerId) {
              <div>
                {{ 'Feedback.CustomerDetails'|translate }}
              </div>
            }
          </div>
        </div>
      }
      <div class="text-sm">{{ 'Feedback.DataDeclarationNoSentDataBeingSold'|translate }}</div>
      <div class="flex flex-col justify-end">
        <button pButton pRipple label="{{'Feedback.DataDeclarationAcceptAndSend'|translate}}"
        (click)="SendFeedback()"></button>
      </div>
    }
    @if (createFeedbackForm.value.feedbackType=='MissingFeature') {
      <div>
        {{ 'Feedback.DataDeclarationSentence1'|translate }}
      </div>
      <div>{{ 'Feedback.DataDeclarationYourAccountInformation'|translate }}</div>
      <div>{{ 'Feedback.DataDeclarationCurrentPage'|translate }}</div>
      <div>{{ 'Feedback.DataDeclarationNoVisibleDataBeingTransmitted'|translate }}</div>
      <div class="text-sm">{{ 'Feedback.DataDeclarationNoSentDataBeingSold'|translate }}</div>
      <div class="flex flex-col justify-end">
        <button pButton pRipple label="{{'Feedback.DataDeclarationAcceptAndSend'|translate}}"
        (click)="SendFeedback()"></button>
      </div>
    }
  </div>
</form>

